<template>
    <div>
        <psi-action-drop-down
            btn-label="Add Students"
            btn-class="secondary darken-2"
            :large="large"
            :heading="`Add Students for ${instructor.name}`"
            :items="items"
            prepend-icon="mdi-account-multiple-plus"
            @action="handleAction"
        >
        </psi-action-drop-down>
        <v-dialog v-model="addDialog" max-width="800">
            <student-add
                v-if="addDialog"
                :add-type="addType"
                @save="addStudents"
                @close="addDialog = false"
            ></student-add>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "add-student-menu",
    components: {
        StudentAdd: () =>
            import("@components/program/components/StudentAdd.vue"),
    },
    props: {
        instructor: {
            type: Object,
            required: true,
        },
        large: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            addType: "",
            addDialog: false,
            items: [
                {
                    icon: "mdi-email",
                    title: "Add students with email addresses",
                    slug: "with-email",
                },
                {
                    divider: true,
                },
                {
                    icon: "mdi-barcode",
                    slug: "without-email",
                    title: "Add students without email access",
                    class: "font-weight-bold primary-text text--darken-2",
                },
            ],
        };
    },
    methods: {
        handleAction(item) {
            this.addType = item.slug;
            this.addDialog = true;
        },
        addStudents(students) {
            this.$emit("add-students", students);
            this.addDialog = false;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>